/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    FeedActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const feedSearchEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.FEED_SEARCH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, FeedActions.feedSearchResults))
);

export const validateFeedEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.FEED_VALIDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, FeedActions.validatedFeed))
);
